// Typelizer digest 0e50d3e2fa9c589c97e369f0603db855
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** GET /c/:company_id/bank_connections/:bank_connection_id/institutions */
  index: (
    params: { bankConnectionId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/bank_connections/:bank_connection_id/institutions', params, options),
    method: 'get',
  }),
}
